import { createContext, useContext, useState, useMemo } from "react";

const ExamModeContext = createContext({
  examMode: false,
  setExamMode: () => {},
});

export function ExamModeProvider({ children }) {
  const [examMode, setExamMode] = useState(false);
  const value = useMemo(() => ({ examMode, setExamMode }), [examMode]);
  return <ExamModeContext.Provider value={value}>{children}</ExamModeContext.Provider>;
}

export function useExamMode() {
  return useContext(ExamModeContext);
}
